import ajax from "./ajax";
export const BASE_URL = "api";
export let CONFIG_URL = "";
export function Axios(dataConfig) {
  dataConfig.url = `${BASE_URL}${CONFIG_URL}/${dataConfig.url}`;
  return ajax(dataConfig);
}
